"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setAOhost = exports.AO_HOST = void 0;
var queryParser_1 = require("../utils/queryParser");
var asset = (0, queryParser_1.default)().asset;
exports.AO_HOST = asset;
var setAOhost = function (val) {
    var currentProtocol = window.location.protocol;
    var assetProtocol = val.split(":")[0] + ":";
    if (currentProtocol === "https:" && assetProtocol === "http:") {
        // In this specific case, we need to request assets over HTTPS
        console.log("Upgrading asset link to https");
        val = val.replace("http:", "https:");
    }
    if (exports.AO_HOST.length < 5 ||
        !exports.AO_HOST ||
        exports.AO_HOST.includes("//attorneyoffline.de/")) {
        exports.AO_HOST = val;
    }
    console.log("Asset URL ist now " + exports.AO_HOST);
};
exports.setAOhost = setAOhost;
